module.exports = __webpack_public_path__ + "img/sonargroup-products.55fb3789.jpg";